/* eslint-disable import/no-named-as-default-member */
import { call, fork, put } from 'redux-saga/effects'
import _ from 'lodash'
import fir from 'firebase/app'
import firebase from '../config/firebase'
import ItemActions from '../reducers/itemReducer'

export function* fetchStoreItems({ restaurantId }) {
  const itemRef = firebase.database().ref(`items/${restaurantId}`)

  const response = yield call([itemRef, itemRef.once], 'value')

  if (response.val() !== null) {
    yield put(ItemActions.fetchItemsByRestaurantSuccess({ [restaurantId]: response.val() }))
  } else {
    yield put(ItemActions.fetchItemsByRestaurantError(null))
  }
}

export function* saveItem({ storeId, itemId, data, callBack }) {
  yield put(ItemActions.setItemAdding(true))

  const updates = {}
  const databaseRef = firebase.database().ref()

  try {
    updates[`items/${storeId}/${itemId}/name`] = data.name
    updates[`items/${storeId}/${itemId}/current_price`] = Number(data.current_price)
    updates[`items/${storeId}/${itemId}/tag`] = data.tag
    updates[`items/${storeId}/${itemId}/code`] = data.code
    updates[`items/${storeId}/${itemId}/status`] = data.status
    updates[`items/${storeId}/${itemId}/description`] = data.description
    updates[`items/${storeId}/${itemId}/modified_at`] = fir.database.ServerValue.TIMESTAMP

    yield call([databaseRef, databaseRef.update], updates)
    yield put(ItemActions.setItem(storeId, itemId, data))
    yield put(ItemActions.setItemAdding(false))
    yield call(callBack)
  } catch (e) {
    alert(e)
    yield put(ItemActions.setItemAdding(false))
  }
}

export function* deleteItem({ storeId, item }) {
  const databaseRef = firebase.database().ref()
  const updates = {}

  updates[`items/${storeId}/${item.id}`] = null

  try {
    yield fork([databaseRef, databaseRef.update], updates)
  } catch (err) {
    alert(err)
  }
}

export function* saveItemArrangement({ storeId, data, callBack }) {
  const databaseRef = firebase.database().ref()
  const updates = {}
  yield put(ItemActions.setArranging(true))

  try {
    const newListItems = {}

    _.map(data, (item, index) => {
      const { itemData } = item
      const { itemKey, ...restData } = itemData

      updates[`items/${storeId}/${item.id}/order_number`] = index + 1
      newListItems[itemKey] = { ...restData, order_number: index + 1 }
    })

    yield call([databaseRef, databaseRef.update], updates)
    yield put(ItemActions.setArranging(false))
    yield put(ItemActions.fetchItemsByRestaurantSuccess({ [storeId]: newListItems }))
    yield call(callBack)
  } catch (err) {
    alert(err)
    yield put(ItemActions.setArranging(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/itemSaga.js